var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-statement"},[_c('p',[_vm._v("copyright © 2022 bubianli.com")])])])
}]

export { render, staticRenderFns }